<template>
	<div class="dashboard-container">
		<div class="waititle" style="font-weight: bold;">
			<div class="blue" />
			实时概况
		</div>
		<div style="margin-bottom: 10px;">
			选择时间
			<el-date-picker label="" type="daterange" value-format="yyyy-MM-dd" v-model="query.time" size="small"
				style="margin-left: 10px;" @change="clean(),getMallData()"></el-date-picker>
			<el-button @click="expore01()" type="primary" size="small" style="margin-left: 10px;">导出</el-button>
		</div>
		<div style="display: flex; width: 1400px;">
		</div>
		<el-row>
			<!-- 商城点击数 -->
			<!-- 			<el-col :span="12">
				<ve-histogram height="500px" :data="mallData" :extend="ex1"></ve-histogram>
			</el-col> -->
			<!-- 支付页点击购买会员数 -->
			<el-col :span="12">
				<ve-histogram height="500px" :data="clickData" :extend="ex1"></ve-histogram>
			</el-col>
			<!-- 支付购买会员数 -->
			<el-col :span="12">
				<ve-histogram height="500px" :data="payData" :extend="ex1"></ve-histogram>
			</el-col>
		</el-row>
		<el-row>
		</el-row>
		<div class="showlist2s">
			<div class="showlist2" style="height:460px;overflow: hidden;">
				<div style="display: flex;">
					<div class="showlist2_1">
						<div class="showlist2_1_title">
							<div class="showlist2_1_1">
								<p>结算金额 (元)</p>
								<p>0.00</p>
							</div>
							<div class="showlist2_1_2">
								<p>昨天全天 (元)</p>
								<p>0.00</p>
							</div>
						</div>
						<div class="showlist2_biao">
							<ve-histogram :data="chartData" height="360px" :extend="typeExted"></ve-histogram>
						</div>
					</div>
					<div class="showlist2_2">
						<div v-for="(item,i) in cardlist1" :key="i" class="cardlist">
							<p>{{item.name}}</p>
							<p>{{item.num}}</p>
							<p>昨日全天{{item.lastnum}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="waititle waititles2" style="font-weight: bold;">
			<div class="waititle1">
				<div class="blue" />核心指标
			</div>
			<div class="waititle2" style="font-weight: 400;">
				时间筛选(自然日)：
				<div style="margin-top: -5px;">
					<el-date-picker size="small" v-model="data" type="date" style="margin-right:10px;"
						placeholder="选择日期" />
				</div>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2" style="height: 850px;">
				<div class="list_wai">
					<div class="mycardlist" v-for="(item,i) in cardlist2" :key="i">
						<div class="mycard_title" :style="{'background':item.color}"></div>
						<div class="mycard_title2">{{item.name}}</div>
						<div class="mycard_title3">{{item.num}}</div>
						<div class="mycard_title4">日环比↑30%</div>
						<div class="mycard_title5">周同比↓30%</div>
					</div>
				</div>
				<div class="list_title">
					指标趋势
				</div>
				<div class="listtwobiao">
					<ve-histogram :data="chartData2" :extend="extend2" :legend-visible="false"></ve-histogram>
				</div>
			</div>
		</div>
		<div class="waititle waititles2" style="font-weight: bold;">
			<div class="waititle1">
				<div class="blue" />流量看板
			</div>
			<div class="waititle2" style="font-weight: 400;">
				<img src="../../../assets/shuju.png" style="width: 24px;height: 18px;transform: translate(0,2px);" />
				<span style="color:#409EFF;margin-left: 10px;font-weight: bold;">流量分析</span>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2">
				<div style="display: flex;">
					<div class="showlist3_1">
						<div class="showlist2_biao">
							<ve-line :data="chartData3" :extend="extend3"></ve-line>
						</div>
					</div>
					<div class="showlist3_2">
						<div class="mycardlist" v-for="i in 2" :key="i">
							<div class="mycard_title2">结算金额 (元)</div>
							<div class="mycard_title3">1000</div>
							<div class="mycard_title4">日环比↓30%</div>
							<div class="mycard_title5">周同比↑30%</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="waititle waititles2" style="font-weight: bold;">
			<div class="waititle1">
				<div class="blue" />转化看板
			</div>
			<div class="waititle2" style="font-weight: 400;">
				<img src="../../../assets/shuju.png" style="width: 24px;height: 18px;transform: translate(0,2px);" />
				<span style="color:#409EFF;margin-left: 10px;font-weight: bold;">门店数据</span>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2">
				<div style="display: flex;">
					<div class="transformation">
						<div class="trancircle">
							<div class="mycard_wen2">{{yuanlist4[0].name}}</div>
							<div class="mycard_wen3">{{yuanlist4[0].percent}}%</div>
							<div class="mycard_wen4">日环比↑30%</div>
							<div class="mycard_wen5">周同比↓30%</div>
						</div>
						<div class="tran_wenzi">
							<div>
								<p>店铺访客数</p>
								<p>{{yuanlist4[0].storenum}}</p>
							</div>
							<div>
								<p>取号人数</p>
								<p>{{yuanlist4[0].peonum}}</p>
							</div>
						</div>
					</div>
					<div class="transformation">
						<div class="trancircle" style="background: #FB697E;">
							<div class="mycard_wen2">{{yuanlist4[1].name}}</div>
							<div class="mycard_wen3">{{yuanlist4[1].percent}}%</div>
							<div class="mycard_wen4">日环比↑30%</div>
							<div class="mycard_wen5">周同比↓30%</div>
						</div>
						<div class="tran_wenzi">
							<div>
								<p>取号客数</p>
								<p>{{yuanlist4[1].storenum}}</p>
							</div>
							<div>
								<p>支付客数</p>
								<p>{{yuanlist4[1].peonum}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="waititle waititles2" style="font-weight: bold;">
			<div class="waititle1">
				<div class="blue" />商品服务
			</div>
			<div class="waititle2" style="font-weight: 400;">
				<img src="../../../assets/shuju.png" style="width: 24px;height: 18px;transform: translate(0,2px);" />
				<span style="color:#409EFF;margin-left: 10px;font-weight: bold;">门店数据</span>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2">
				<div style="display: flex;">
					<div class="tablelist">
						<div class="biaoge">
							<div class="head">销量TOP5店</div>
							<el-table :data="tableData" border style="width: 100%">
								<el-table-column prop="address" align="center" label="TOP"></el-table-column>
								<el-table-column prop="address" align="center" label="服务名称"></el-table-column>
								<el-table-column prop="name" align="center" label="复购率"></el-table-column>
								<el-table-column prop="name" align="center" label="客数"></el-table-column>
							</el-table>
						</div>
					</div>
					<div class="tablelist">
						<div class="biaoge">
							<div class="head">销量TOP5店</div>
							<el-table :data="tableData" border style="width: 100%">
								<el-table-column prop="date" align="center" label="TOP"></el-table-column>
								<el-table-column prop="address" align="center" label="服务名称"></el-table-column>
								<el-table-column prop="name" align="center" label="复购率"></el-table-column>
								<el-table-column prop="name" align="center" label="客数"></el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="waititle waititles2" style="font-weight: bold;">
			<div class="waititle1">
				<div class="blue" />店铺看板
			</div>
			<div class="waititle2" style="font-weight: 400;">
				<img src="../../../assets/shuju.png" style="width: 24px;height: 18px;transform: translate(0,2px);" />
				<span style="color:#409EFF;margin-left: 10px;font-weight: bold;">门店数据</span>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2">
				<div style="display: flex;">
					<div class="tablelist">
						<div class="biaoge">
							<div class="head">取号访客TOP5店铺</div>
							<el-table :data="tableData" border style="width: 100%">
								<el-table-column prop="address" align="center" label="TOP"></el-table-column>
								<el-table-column prop="address" align="center" label="服务名称"></el-table-column>
								<el-table-column prop="name" align="center" label="复购率"></el-table-column>
								<el-table-column prop="name" align="center" label="客数"></el-table-column>
							</el-table>
						</div>
					</div>
					<div class="tablelist">
						<div class="biaoge">
							<div class="head">支付访客TOP5店铺</div>
							<el-table :data="tableData" border style="width: 100%">
								<el-table-column prop="date" align="center" label="TOP"></el-table-column>
								<el-table-column prop="address" align="center" label="服务名称"></el-table-column>
								<el-table-column prop="name" align="center" label="复购率"></el-table-column>
								<el-table-column prop="name" align="center" label="客数"></el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="waititle waititles2" style="font-weight: bold;">
			<div class="waititle1">
				<div class="blue" />用户看板
			</div>
			<div class="waititle2" style="font-weight: 400;">
				<img src="../../../assets/shuju.png" style="width: 24px;height: 18px;transform: translate(0,2px);" />
				<span style="color:#409EFF;margin-left: 10px;font-weight: bold;">用户数据</span>
			</div>
		</div>
		<div class="showlist2s" style="display: flex;">
			<div class="showlist2" style="margin-right:15px;">
				<div class="list7_1">
					<div class="list7_title">一般用户</div>
					<div class="list7_2">
						<div class="list_card" v-for="(i,k) in menulist1" :key="k">
							<div class="list_card1">{{i.name}}</div>
							<div class="list_card2">100</div>
							<div class="list_card3">日环比↑30%</div>
							<div class="list_card4">周同比↓30%</div>
						</div>
					</div>
					<div class="list7_biao">
						<ve-line :data="chartData7_1" height="280px" :extend="extend7_1"></ve-line>
					</div>
				</div>
			</div>
			<div class="showlist2">
				<div class="list7_1">
					<div class="list7_title">付费用户</div>
					<div class="list7_2">
						<div class="list_card" v-for="(i,k) in menulist2" :key="k">
							<div class="list_card1">{{i.name}}</div>
							<div class="list_card2">100</div>
							<div class="list_card3">日环比↑30%</div>
							<div class="list_card4">周同比↓30%</div>
						</div>
					</div>
					<div class="list7_biao">
						<ve-line :data="chartData7_2" height="280px" :extend="extend7_1"></ve-line>
					</div>
				</div>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2">
				<div class="last_title">店铺付费新老用户</div>
				<div class="last_list">
					<div class="last_lists">
						<ve-ring legend-position="left" :settings="chartSettings" :extend="extend8"
							:data="chartData_81" />
					</div>
					<div class="last_lists">
						<ve-ring legend-position="left" :settings="chartSettings" :extend="extend82s"
							:data="chartData_82" />
					</div>
					<div class="last_lists2">
						<div class="last_title">客户复购率</div>
						<div class="list_both">
							<div class="list_both1">
								<div>本周</div>
								<div>90.46%</div>
								<div>较上一周</div>
							</div>
							<div class="list_both1">
								<div>本周</div>
								<div>90.46%</div>
								<div>较上一周</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		url
	} from '../../../utils/index.js'
	export default {
		data() {
			this.extend1 = {
					series: {
						label: {
							show: true,
							position: "top"
						}
					}
				},
				this.chart1 = {},
				this.chartSettings = {
					label: {
						normal: {
							show: false,
						}
					}
				},
				this.chartExtend = {
					color: ['#FB697E', '#845FFD']
				}
			return {
				url: url(),
				query: {
					time: '',
					startTime: '',
					endTime: ''
				},
				menulist1: [{
					name: "累积用户"
				}, {
					name: "新增用户"
				}, {
					name: "活跃用户"
				}],
				menulist2: [{
					name: "累计付费用户"
				}, {
					name: "付费用户"
				}, {
					name: "活跃付费用户"
				}],
				//第一节数据
				cardlist1: [{
					name: "访客数",
					num: 100,
					lastnum: 10
				}, {
					name: "付款用户数",
					num: 1000,
					lastnum: 10
				}, {
					name: "游览数",
					num: 100,
					lastnum: 10
				}, {
					name: "订单支付数",
					num: 100,
					lastnum: 10
				}],
				mallData: {
					columns: ['日期', '商城点击数'],
					rows: []
				},
				payData: {
					columns: ['日期', '支付页购买会员人数'],
					rows: []
				},
				clickData: {
					columns: ['日期', '支付页点击会员人数'],
					rows: []
				},
				chartData: {
					columns: ['日期', '昨日收益', '今日收益'],
					rows: [{
						'日期': '1/1',
						'昨日收益': 1393,
						'今日收益': 1393
					}, {
						'日期': '1/2',
						'昨日收益': 3530,
						'今日收益': 1393
					}, {
						'日期': '1/3',
						'昨日收益': 2923,
						'今日收益': 1393
					}, {
						'日期': '1/4',
						'昨日收益': 1723,
						'今日收益': 1393
					}, {
						'日期': '1/5',
						'昨日收益': 3792,
						'今日收益': 1393
					}, {
						'日期': '1/2',
						'昨日收益': 3530,
						'今日收益': 1393
					}, {
						'日期': '1/3',
						'昨日收益': 2923,
						'今日收益': 1393
					}, {
						'日期': '1/4',
						'昨日收益': 1723,
						'今日收益': 1393
					}, {
						'日期': '1/5',
						'昨日收益': 3792,
						'今日收益': 1393
					}, {
						'日期': '1/2',
						'昨日收益': 3530,
						'今日收益': 1393
					}, {
						'日期': '1/3',
						'昨日收益': 2923,
						'今日收益': 1393
					}, {
						'日期': '1/4',
						'昨日收益': 1723,
						'今日收益': 1393
					}, {
						'日期': '1/5',
						'昨日收益': 3792,
						'今日收益': 1393
					}, {
						'日期': '1/6',
						'昨日收益': 4593,
						'今日收益': 1393
					}]
				},
				ex1: {
					color: ['#397eff', '#FB697E']
				},
				//第二节数据 
				cardlist2: [{
					color: "#2CDDCF",
					name: "结算金额（元）",
					num: "100"
				}, {
					name: "游客数",
					num: "100",
					color: "#FFA33E"
				}, {
					name: "支付转化率",
					num: "100",
					color: "#3F9EFF"
				}, {
					name: "客单价（元）",
					num: "100",
					color: "#8361FC"
				}, {
					name: "客单价（元）",
					num: "100",
					color: "#FE697B"
				}, {
					name: "客单价（元）",
					num: "100",
					color: "#FF7C42"
				}, {
					name: "客单价（元）",
					num: "100",
					color: "#FF40CA"
				}, {
					name: "客单价（元）",
					num: "100",
					color: "#8563FE"
				}, {
					name: "客单价（元）",
					num: "100",
					color: "#FA6367"
				}],
				typeExted: {
					series: {
						center: ["40%", "50%"],
					},
					legend: {
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				chartData2: {
					columns: ['日期', '访问用户', '下单用户', '下单率'],
					rows: [{
						'日期': '2008-08-24',
						'访问用户': 1393,
						'下单率': 0.32
					}, {
						'日期': '2008-08-25',
						'访问用户': 3530,
						'下单率': 0.26
					}, {
						'日期': '2008-08-26',
						'访问用户': 2923,
						'下单率': 0.76
					}, {
						'日期': '2008-08-25',
						'访问用户': 3530,
						'下单率': 0.26
					}, {
						'日期': '2008-08-26',
						'访问用户': 2923,
						'下单率': 0.76
					}, {
						'日期': '2008-08-25',
						'访问用户': 3530,
						'下单率': 0.26
					}, {
						'日期': '2008-08-26',
						'访问用户': 2923,
						'下单率': 0.76
					}, {
						'日期': '2008-08-25',
						'访问用户': 3530,
						'下单率': 0.26
					}, {
						'日期': '2008-08-26',
						'访问用户': 2923,
						'下单率': 0.76
					}]
				},
				extend2: {
					color: ["#865FFC"]
				},
				// 第三节数据
				extend3: {
					legend: {
						icon: "circle",
						right: 100,
						top: 10
					},
					series: {
						center: ["60%", "40%"]
					},
					color: ['#8262F4', '#FB6883']
				},
				chartData3: {
					columns: ['日期', '今日用户', '下单用户'],
					rows: [{
						'日期': '2008-08-24',
						'今日用户': 1393,
						'下单用户': 3530
					}, {
						'日期': '2008-08-25',
						'今日用户': 3530,
						'下单用户': 3031
					}, {
						'日期': '2008-08-26',
						'今日用户': 2923,
						'下单用户': 2345
					}, {
						'日期': '2008-08-27',
						'今日用户': 3530,
						'下单用户': 1356
					}, {
						'日期': '2008-08-28',
						'今日用户': 2923,
						'下单用户': 0.76
					}, {
						'日期': '2008-08-29',
						'今日用户': 3530,
						'下单用户': 6442
					}, {
						'日期': '2008-08-30',
						'今日用户': 2923,
						'下单用户': 4654
					}, {
						'日期': '2008-09-01',
						'今日用户': 3530,
						'下单用户': 1846
					}, {
						'日期': '2008-09-02',
						'今日用户': 2923,
						'下单用户': 3579
					}]
				},
				// 第四节数据
				yuanlist4: [{
					name: "访客取号转化率",
					percent: 87.56,
					storenum: 100,
					peonum: 100
				}, {
					name: "访客取号转化率",
					percent: 67.56,
					storenum: 100,
					peonum: 100
				}, ],
				// 第七节数据
				chartData7_1: {
					columns: ['日期', '累计用户', '新增用户', '活跃用户'],
					rows: [{
						'日期': '2008-08-24',
						'累计用户': 1393,
						'新增用户': 3530,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-25',
						'累计用户': 3530,
						'新增用户': 3031,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-26',
						'累计用户': 2923,
						'新增用户': 2345,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-27',
						'累计用户': 3530,
						'新增用户': 1356,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-28',
						'累计用户': 2923,
						'新增用户': 0.76,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-29',
						'累计用户': 3530,
						'新增用户': 6442,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-30',
						'累计用户': 2923,
						'新增用户': 4654,
						'活跃用户': 1345
					}, {
						'日期': '2008-09-01',
						'累计用户': 3530,
						'新增用户': 1846,
						'活跃用户': 1345
					}, {
						'日期': '2008-09-02',
						'累计用户': 2923,
						'新增用户': 3579,
						'活跃用户': 1345
					}]
				},
				chartData7_2: {
					columns: ['日期', '累计用户', '新增用户', '活跃用户'],
					rows: [{
						'日期': '2008-08-24',
						'累计用户': 1393,
						'新增用户': 3530,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-25',
						'累计用户': 3530,
						'新增用户': 3031,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-26',
						'累计用户': 2923,
						'新增用户': 2345,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-27',
						'累计用户': 3530,
						'新增用户': 1356,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-28',
						'累计用户': 2923,
						'新增用户': 0.76,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-29',
						'累计用户': 3530,
						'新增用户': 6442,
						'活跃用户': 1345
					}, {
						'日期': '2008-08-30',
						'累计用户': 2923,
						'新增用户': 4654,
						'活跃用户': 1345
					}, {
						'日期': '2008-09-01',
						'累计用户': 3530,
						'新增用户': 1846,
						'活跃用户': 1345
					}, {
						'日期': '2008-09-02',
						'累计用户': 2923,
						'新增用户': 3579,
						'活跃用户': 1345
					}]
				},
				extend7_1: {
					legend: {
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
					series: {
						center: ["60%", "40%"]
					},
					color: ['#2EDBCF', '#FDA64B', '#8262F9']
				},
				// 第八节数据
				extend8: {
					series: {
						center: ["60%", "38%"],
					},
					legend: {
						left: 10,
						top: 123,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
					color: ["#2DDDCB", "#8560FA"]
				},
				extend82s: {
					series: {
						center: ["60%", "38%"],
					},
					legend: {
						left: 10,
						top: 123,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
					color: ["#FBA542", "#FC697D"]
				},
				chartData_81: {
					columns: ['日期', '访问用户'],
					rows: [{
						日期: '新付费用户结算比例',
						访问用户: 1393
					}, {
						日期: '老付费用户结算比例',
						访问用户: 3530
					}]
				},
				chartData_82: {
					columns: ['日期', '访问用户'],
					rows: [{
						日期: '新付费用户结算比例',
						访问用户: 1393
					}, {
						日期: '老付费用户结算比例',
						访问用户: 3530
					}]
				},
				// <ve-ring legend-position="left"  :settings="chartSettings" :extend="extend8" :data="chartData_81"  />	
				evlData: {
					columns: ["类型", "数量"],
					rows: [{
						类型: "剪发",
						数量: 1530
					}, {
						类型: "儿童剪",
						数量: 2393
					}, {
						类型: "刘海剪",
						数量: 2393
					}],
				},
				evlExted: {
					series: {
						center: ["40%", "50%"],
					},
					legend: {
						left: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				sextend: {
					legend: {
						icon: "circle",
						left: 60,
						top: 140
					},
					series: {
						center: ["60%", "40%"]
					},
					color: ['#409EFC', '#FB697E']
				},
				evlColor: ["#FFA242", "#2DDFCF", "#FA6A7D", "#FB697E", "#845FFC"],
				sextend2: {
					legend: {
						icon: "circle",
						right: 40,
						top: 20
					},
					series: {
						center: ["40%", "40%"]
					},
					color: ['#FB697E', '#845FFD']
				},
				sextend3: {
					legend: {
						icon: "circle",
						right: 40,
						top: 20
					},
					series: {
						center: ["40%", "40%"]
					},
					color: ['#FB697E', '#845FFD']
				},
				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '123456'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '123456'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '123456'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '123456'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '123456'
				}],
				user: '',
				listtime: '',
				data: '',
				activeName: 'two',
				friendsnum: [{
					name: '累计会员数'
				}],
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				option2: [{
					value: '选项1',
					label: '今天'
				}, {
					value: '选项2',
					label: '明天'
				}, {
					value: '选项3',
					label: '后天'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
			}
		},
		mounted() {
			this.getMallData()
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event)
			},
			getMallData() {
				if (this.query.time != null) {
					var s = this.query.time[0]
					var e = this.query.time[1]
				}
				this.$http.get("dbarrel/findMallData" + "?startTime=" + s + "&endTime=" + e).then(res => {
					var a = res.body.data
					// 商城点击数
					var list1 = a.filter(ele => ele.type == 0)
					// 支付页会员购买数
					var list2 = a.filter(ele => ele.type == 1)
					// 支付页会员点击数
					var list3 = a.filter(ele => ele.type == 2)
					for (var i = 0; i < list1.length; i++) {
						var a = {
							["日期"]: list1[i].date,
							["商城点击数"]: list1[i].count
						}
						this.mallData.rows.push(a)
					}
					//支付页会员购买数
					for (var i = 0; i < list2.length; i++) {
						var a = {
							["日期"]: list2[i].date,
							["支付页购买会员人数"]: list2[i].count
						}
						this.payData.rows.push(a)
					}
					// 支付页会员点击数
					for (var i = 0; i < list3.length; i++) {
						var a = {
							["日期"]: list3[i].date,
							["支付页点击会员人数"]: list3[i].count
						}
						this.clickData.rows.push(a)
					}
				})
			},
			clean() {
				this.mallData.rows = []
				this.payData.rows = []
				this.clickData.rows = []
			},
			// 点击数导出
			expore01() {
				var a = "";
				if (this.query.time != 'underfine' && this.query.time != '') {
					a = "?startTime=" + this.query.time[0] + "&endTime=" + this.query.time[1]
				}
				window.location.assign(this.url + "dbarrel/export01" + a)
			}
		}
	}
</script>
<style scoped="scoped" lang="less">
	.table_title {
		width: 100%;
		height: 2.625rem;
		background-color: #F2F2F2;
		color: #9C9C9C;
		text-align: center;
		line-height: 2.625rem;
	}

	.waititles2 {
		margin-top: 20px;
	}

	.waititle {
		width: 100%;
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.waititle1 {
			display: flex;
			flex: 1;
		}

		.waititle2 {
			display: flex;
		}

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.showlist2s {
		width: 100%;
		padding: 4px;
		box-sizing: border-box;

		// 第一节
		.showlist2 {
			padding: 20px;
			box-sizing: border-box;
			width: 100%;
			background: #ffffff;
			box-shadow: 0px 2px 9px 0px rgba(#0000, 0.09);

			.showlist2_1 {
				flex: 1;

				.showlist2_1_title {
					display: flex;
					text-align: center;

					div {
						flex: 1;

						p {
							&:nth-child(1) {
								font-size: 16px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #3E3E3E;
								line-height: 0;
							}

							&:nth-child(2) {
								line-height: 0;
								font-size: 40px;
								font-family: Source Han Sans CN;
								font-weight: 500;
								color: #3E3E3E;
							}
						}
					}
				}
			}

			.showlist2_2 {
				flex: 1;
				display: flex;
				flex-wrap: wrap;
				box-sizing: border-box;
				padding-top: 60px;
				height: 420px;

				.cardlist {
					margin-left: 4%;
					width: 46%;
					height: 155px;
					background: #F2F2F2;
					border-radius: 6px;
					box-sizing: border-box;
					padding-left: 20px;

					p {
						&:nth-child(1) {
							background: #F2F2F2;
							border-radius: 6px;
							line-height: 0;
							padding-top: 20px;
						}

						&:nth-child(2) {
							font-size: 40px;
							font-family: Source Han Sans CN;
							font-weight: 500;
							color: #3E3E3E;
							line-height: 0;
							padding-top: 1px;
						}

						&:nth-child(3) {
							font-size: 16px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #3E3E3E;
							line-height: 0;
							padding-top: 10px;
						}
					}
				}
			}

			.showlist3_2 {
				box-sizing: border-box;
				height: 420px;

				.mycardlist {
					width: 271px;
					height: 175px;
					background: #F2F2F2;
					border-radius: 6px;

					&:nth-child(2) {
						margin-top: 20px;
					}

					.mycard_title2 {
						margin-left: 15px;
						margin-top: 13px;
						background: #F2F2F2;
						border-radius: 6px;
					}

					.mycard_title3 {
						margin-left: 15px;
						margin-top: 10px;
						font-size: 40px;
						font-family: Source Han Sans CN;
						font-weight: 500;
						color: #3E3E3E;
					}

					.mycard_title4 {
						margin-left: 15px;
						margin-top: 13px;
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3E3E3E;
					}

					.mycard_title5 {
						margin-left: 15px;
						margin-top: 10px;
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3E3E3E;
					}
				}

			}

			// 第三节
			.showlist3_1 {
				flex: 1;
				margin-right: 20px;
			}
		}

		// 第二节
		.list_wai {
			display: flex;
			width: 100%;
			flex-wrap: wrap;
		}

		.mycardlist {
			height: 193px;
			background: #F2F2F2;
			border-radius: 6px;
			width: 15%;
			margin-right: 2%;
			overflow: hidden;

			&:nth-child(6) {
				margin: 0;
			}

			&:nth-child(n+7) {
				margin-top: 25px;
			}

			.mycard_title {
				height: 18px;
			}

			.mycard_title2 {
				margin-left: 15px;
				margin-top: 13px;
				background: #F2F2F2;
				border-radius: 6px;
			}

			.mycard_title3 {
				margin-left: 15px;
				margin-top: 10px;
				font-size: 40px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #3E3E3E;
			}

			.mycard_title4 {
				margin-left: 15px;
				margin-top: 13px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #3E3E3E;
			}

			.mycard_title5 {
				margin-left: 15px;
				margin-top: 10px;
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #3E3E3E;
			}
		}

		.list_title {
			margin-top: 20px;
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #3E3E3E;
		}

		// 第四节、
		.transformation {
			padding-left: 5%;
			flex: 1;
			box-sizing: border-box;
			display: flex;

			.trancircle {
				padding-top: 55px;
				box-sizing: border-box;
				width: 286px;
				height: 286px;
				background: #845FFC;
				border-radius: 50%;

				.mycard_wen2 {
					text-align: center;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #FFFFFF;
				}

				.mycard_wen3 {
					text-align: center;
					font-size: 48px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #FFFFFF;
					margin-top: 20px;
				}

				.mycard_wen4 {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #FFFFFF;
					margin-top: 25px;
					margin-left: 30%;
				}

				.mycard_wen5 {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #FFFFFF;
					margin-top: 10px;
					margin-left: 30%;
				}
			}

			.tran_wenzi {
				margin-left: 50px;

				div {
					&:nth-child(1) {
						margin-top: 40px;
					}

					&:nth-child(2) {
						margin-top: 100px;
					}

					p {
						&:nth-child(1) {
							text-align: center;
							line-height: 0;
							font-size: 18px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #494949;
						}

						&:nth-child(2) {
							text-align: center;
							line-height: 0;
							font-size: 48px;
							font-family: Source Han Sans CN;
							font-weight: 500;
							color: #3F3F3F;
						}
					}
				}
			}
		}

		// 第六节
		.tablelist {
			flex: 1;

			&:nth-child(1) {
				margin-right: 30px;
			}
		}

		// 第七节
		.list7_2 {
			display: flex;

			.list_card {
				margin-top: 10px;
				flex: 1;
				height: 163px;
				background: #F2F2F2;
				border-radius: 6px;
				box-sizing: border-box;
				padding-left: 20px;

				&:nth-child(n+2) {
					margin-left: 15px;
				}

				.list_card1 {
					margin-top: 15px;
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #3E3E3E;
				}

				.list_card2 {
					margin-top: 10px;
					font-size: 40px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #3E3E3E;
				}

				.list_card3 {
					margin-top: 5px;
				}

				.list_card4 {
					margin-top: 5px;
				}
			}
		}

		// 最后一节
		.last_lists2 {
			.last_title {
				font-size: 16px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #3E3E3E;
				margin-top: 40px;
			}

			.list_both {
				display: flex;
				margin-top: 40px;

				.list_both1 {
					flex: 1;

					div {
						&:nth-child(1) {
							font-size: 16px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #3E3E3E;
						}

						&:nth-child(2) {
							margin-top: 20px;
							font-size: 40px;
							font-family: Source Han Sans CN;
							font-weight: bold;
							color: #3E3E3E;
						}

						&:nth-child(3) {
							margin-top: 20px;
							font-size: 16px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #3E3E3E;
						}
					}
				}
			}
		}

		// <div class="last_lists2">
		// 	  	<div class="last_title">客户复购率</div>
		// 		<div class="list_both">
		// 			<div class="list_both1">
		// 				<div>本周</div>
		// 				<div>90.46%</div>
		// 				<div>较上一周</div>
		// 			</div>
		// 			<div class="list_both1">
		// 				<div>本周</div>
		// 				<div>90.46%</div>
		// 				<div>较上一周</div>
		// 			</div>
		// 		</div>
		// </div>
		.list7_biao {
			margin-top: 20px;
			height: 250px;
			overflow: hidden;
		}

		.last_list {
			height: 275px;
			overflow: hidden;
			margin-top: -20px;
			display: flex;

			.last_lists {
				flex: 1.2;
			}

			.last_lists2 {
				flex: 1;
			}
		}

		.biaoge {
			width: 100%;

			.head {
				width: 100%;
				background-color: #DFDFDF;
				text-align: center;
				color: #8C8C8C;
				padding: 10px 0;
			}
		}
	}
</style>